import { Button } from "antd";
import React, { useState } from "react";
import ModalEditTrip from "../modal/ModalEditTrip";
import { EditOutlined } from "@ant-design/icons";
import { useModalLockScroll } from "../../../../hooks/useModalLockScroll";

interface ButtonEditTripProps {
  // Add props here
  tripId: string;
  onSuccess?: () => void;
}

const ButtonEditTrip: React.FC<ButtonEditTripProps> = (
  props: ButtonEditTripProps
) => {
  const { tripId, onSuccess } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);
    useModalLockScroll(isModalOpen);
  return (
    <div>
      <Button  icon={<EditOutlined />}onClick={showModal} className="font-medium">
        Cập nhật
      </Button>
      <ModalEditTrip
        tripId={tripId}
        onClose={handleCancel}
        visible={isModalOpen}
        onSuccess={onSuccess}
      />
    </div>
  );
};

export default ButtonEditTrip;
